import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ANALYTICS_STORAGE_KEYS } from 'shared/constants';

const isBrowser = typeof window !== 'undefined';

// Cache the visitorId for sync access
let visitorId = null;

/**
 * Generate a new device fingerprint using FingerprintJS.
 */
const generateFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    visitorId = result.visitorId;
    localStorage.setItem(ANALYTICS_STORAGE_KEYS.DEVICE_ID, visitorId);
    console.debug('[DeviceFingerprint] Generated new device ID:', visitorId);

    return visitorId;
  } catch (error) {
    console.error('[DeviceFingerprint] Error:', error);
    return null;
  }
};

/**
 * Initialize device fingerprint.
 * - Uses cached ID from localStorage if available
 * - Generates new fingerprint only when no cache exists
 */
const initPromise = (async () => {
  if (!isBrowser) {
    return null;
  }

  // Check localStorage cache first
  const cachedId = localStorage.getItem(ANALYTICS_STORAGE_KEYS.DEVICE_ID);
  if (cachedId) {
    visitorId = cachedId;
    console.debug('[DeviceFingerprint] Using cached device ID:', visitorId);
    return visitorId;
  }

  // No cache - generate new fingerprint
  return generateFingerprint();
})();

/**
 * Get the device ID.
 * - Returns cached value immediately for returning visits.
 * - Awaits initialization for first visit (race condition fix).
 */
export const getDeviceId = async () => {
  if (visitorId) {
    return visitorId;
  }
  return initPromise;
};
